import { useSalonContext } from '@customer/components/pages/Salon/context'
import UnexpectedSalonTypeError from '@errors/UnexpectedSalonTypeError'
import React from 'react'
import SalonCurrentStatus from './components/CurrentStatus'
import SalonFinishedStatus from './components/FinishedStatus/SalonFinishedStatus'
import SalonVotingStatus from './components/VotingStatus/SalonVotingStatus'

export default function SalonStatusByType() {
    const { salon } = useSalonContext()

    switch (salon.state.type) {
        case 'current':
            return <SalonCurrentStatus />
        case 'voting':
            return <SalonVotingStatus />
        case 'finished':
            return <SalonFinishedStatus />
        default:
            throw new UnexpectedSalonTypeError(salon.state.type)
    }
}